import styled from 'styled-components';
import { rem } from '@/styles/theme';

interface IProps {
  theme: any;
  sticky: boolean;
  firstIncome: boolean;
  isOrganicUser: boolean;
  isNotLGU: boolean;
}

export const Wrapper = styled.div<IProps>`
  position: -webkit-sticky;
  position: sticky;
  box-sizing: border-box;
  padding: ${rem(8)} ${rem(18)};
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(15px);
  width: 100vw;
  max-width: ${rem(414)};
  overflow-x: scroll;
  z-index: 100;
  transition: all 0.3s ease-in-out;
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }

  &::-webkit-scrollbar {
    display: none;
    height: 0;
    background-color: transparent;
  }
  ${({ sticky, theme, firstIncome, isOrganicUser, isNotLGU }) =>
    sticky
      ? isOrganicUser && firstIncome && isNotLGU
        ? `top:${rem(80)}`
        : `top: ${rem(52)}`
      : `
    top: -7rem;
    border-bottom: 0;
  `}
`;

export const NavList = styled.div`
  display: inline-flex;
  width: max-content;
  gap: ${rem(15)};
`;
